import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { WEBINAR_DATE_ISO, WEBINAR_DURATION_MIN } from "./copy";
import { Countdown } from "./Countdown";

const pad = (n) => String(n).padStart(2, "0");
const toUtcStamp = (d) =>
  `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

const eventTimes = () => {
  const start = new Date(WEBINAR_DATE_ISO);
  const end = new Date(start.getTime() + WEBINAR_DURATION_MIN * 60000);
  return { start, end };
};

const googleCalUrl = (title, details) => {
  const { start, end } = eventTimes();
  const p = new URLSearchParams({
    action: "TEMPLATE",
    text: title,
    dates: `${toUtcStamp(start)}/${toUtcStamp(end)}`,
    details,
    location: "Online — link sent by email",
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};

const downloadIcs = (title, details) => {
  const { start, end } = eventTimes();
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Strategic Buyer Session//EN",
    "BEGIN:VEVENT",
    `UID:${Date.now()}@strategicbuyersession`,
    `DTSTAMP:${toUtcStamp(new Date())}`,
    `DTSTART:${toUtcStamp(start)}`,
    `DTEND:${toUtcStamp(end)}`,
    `SUMMARY:${title}`,
    `DESCRIPTION:${details}`,
    "LOCATION:Online — link sent by email",
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "strategic-buyer-session.ics";
  a.click();
  URL.revokeObjectURL(a.href);
};

export const ThankYou = ({ t, lang }) => {
  const ty = t.thankyou;
  const title = lang === "es" ? "La Sesión del Comprador Estratégico — Plinio Angulo" : "The Strategic Buyer Session — Plinio Angulo";
  const details = t.card.trust;
  return (
    <div className="min-h-screen grid-bg flex items-center justify-center px-6 py-20" data-testid="thank-you-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="glass-card p-8 md:p-12 max-w-xl w-full text-center"
      >
        <div className="w-16 h-16 mx-auto rounded-full bg-[#4D9FFF] text-white flex items-center justify-center text-3xl font-black mb-6">✓</div>
        <div className="mono accent text-[10px] tracking-[0.35em] mb-4">{ty.tag}</div>
        <h1 className="h1-display text-3xl md:text-4xl mb-5">{ty.title}</h1>
        <p className="text-white/55 text-[15px] leading-relaxed mb-4">{ty.body}</p>
        <div className="mono text-[11px] tracking-[0.2em] text-white/35 mb-8" data-testid="thank-you-date">
          {t.dateLine}
        </div>
        <div className="flex justify-center mb-8"><Countdown t={t} /></div>
        <div className="space-y-3">
          <a
            data-testid="add-google-calendar-btn"
            href={googleCalUrl(title, details)}
            target="_blank"
            rel="noreferrer"
            className="btn-accent block w-full py-4 text-sm tracking-widest uppercase"
          >
            {ty.google}
          </a>
          <button
            data-testid="download-ics-btn"
            onClick={() => downloadIcs(title, details)}
            className="btn-outline block w-full py-4 text-sm tracking-widest uppercase"
          >
            {ty.ics}
          </button>
        </div>
        <p className="text-[10px] text-white/25 mt-6">{t.card.trust}</p>
        <Link data-testid="back-home-link" to="/" className="mono inline-block mt-8 text-[11px] tracking-[0.2em] text-white/45 hover:text-[#4D9FFF] transition-colors">
          {ty.back}
        </Link>
      </motion.div>
    </div>
  );
};
